import React from 'react';

export type OverviewContextType = {
  onDeleteCreditsPoolClick: (id: string, name: string) => void;
  onArchiveCreditsPoolClick: (id: string, name: string) => void;
};

const CreditsPoolsDashboardContext = React.createContext<OverviewContextType>({
  onDeleteCreditsPoolClick: (() => console.warn('CreditsPoolsDashboardContext: onDeleteCreditsPoolClick provider missing')),
  onArchiveCreditsPoolClick: (() => console.warn('CreditsPoolsDashboardContext: onArchiveCreditsPoolClick provider missing'))
});

export { CreditsPoolsDashboardContext };
